
import { useRef } from 'react';

export default function Portfolio() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const projects = [
    {
      image: 'https://public.readdy.ai/ai/img_res/085070172d9218847070a29c7f7335cc.jpg',
      title: 'Modern Kitchen Remodel',
      category: 'Residential Construction'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=custom%20built-in%20closet%20system%20with%20elegant%20wooden%20shelving%20modern%20organization%20solution%20premium%20craftsmanship%20professional%20carpentry%20photography%20warm%20lighting&width=600&height=600&seq=port002&orientation=squarish',
      title: 'Custom Closet System',
      category: 'Fine Frank Cabinets'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=commercial%20office%20space%20renovation%20modern%20professional%20workspace%20contemporary%20design%20clean%20lines%20business%20interior%20photography%20natural%20lighting&width=600&height=600&seq=port003&orientation=squarish',
      title: 'Office Build-Out',
      category: 'Commercial Construction'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=luxury%20bathroom%20renovation%20with%20marble%20tiles%20modern%20fixtures%20elegant%20vanity%20professional%20interior%20photography%20spa-like%20atmosphere%20high-end%20residential%20remodeling&width=600&height=600&seq=port004&orientation=squarish',
      title: 'Master Bathroom Renovation',
      category: 'Residential Construction'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=custom%20entertainment%20center%20with%20built-in%20TV%20panel%20modern%20wooden%20cabinetry%20sleek%20design%20professional%20carpentry%20photography%20contemporary%20living%20room&width=600&height=600&seq=port005&orientation=squarish',
      title: 'Entertainment Center',
      category: 'Fine Frank Cabinets'
    }
  ];

  return (
    <section id="portfolio" className="py-24 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="flex justify-between items-center mb-12">
          <button className="px-6 py-2.5 border border-white/30 text-white text-sm font-light rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
            VIEW ALL PROJECTS
          </button>
          <h2 className="text-5xl font-extrabold text-white">
            Our Recent Projects
          </h2>
        </div>

        {/* Portfolio Grid */}
        <div 
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {projects.map((project, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-80 bg-[#F5F1E8] rounded-xl overflow-hidden hover:scale-105 transition-transform cursor-pointer"
            >
              <div className="w-full h-80">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="bg-[#0A0A0A] p-6">
                <h3 className="text-lg font-semibold text-white mb-1">
                  {project.title}
                </h3>
                <p className="text-sm text-gray-400">
                  {project.category}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
